import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faReact, faJs, faHtml5, faCss3, faGitAlt } from '@fortawesome/free-brands-svg-icons'
import './index.scss'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = ['z', 'a', 'i', 'r', ',']
  const jobArray = [
    's',
    'o',
    'f',
    't',
    'w',
    'a',
    'r',
    'e',
    ' ',
    'd',
    'e',
    'v',
    'e',
    'l',
    'o',
    'p',
    'e',
    'r',
    '.',
  ]

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>{' '}
            <span className={`special-u ${letterClass}`}>U</span>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
            />
          </h1>
          <h2>Developer / Real life Solutions  / Student</h2>
          <div className="tech-stack-row">
            <FontAwesomeIcon icon={faReact} className="tech-icon react" />
            <FontAwesomeIcon icon={faJs} className="tech-icon js" />
            <FontAwesomeIcon icon={faHtml5} className="tech-icon html5" />
            <FontAwesomeIcon icon={faCss3} className="tech-icon css3" />
            <FontAwesomeIcon icon={faGitAlt} className="tech-icon git" />
          </div>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        {/* Tech/code motif SVG */}
        <svg className="hero-geo-shape" width="600" height="300" viewBox="0 0 600 300" fill="none" xmlns="http://www.w3.org/2000/svg">
          <text x="60" y="220" fontFamily="'Montserrat', monospace" fontWeight="700" fontSize="220" fill="#ffd700" fillOpacity="0.10" >{'{}'}</text>
          <text x="250" y="220" fontFamily="'Montserrat', monospace" fontWeight="700" fontSize="220" fill="#ffd700" fillOpacity="0.10" >'</text>
          <text x="400" y="220" fontFamily="'Montserrat', monospace" fontWeight="700" fontSize="220" fill="#ffd700" fillOpacity="0.10" >'</text>
        </svg>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Home